import React, { FC } from 'react'

import { IconBackspaceProps } from './IconBackspace.types'
import * as Styled from './styles/IconBackspace.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBackspace: FC<IconBackspaceProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBackspaceProps['size'],
  isResponsive = false,
}: IconBackspaceProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#7dce32a7-0639-42d2-a7fe-38ce7e85d6db__a)' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
          <path
            d='M43.028 15.113v18a4 4 0 0 1-4 4H15.265a4.001 4.001 0 0 1-3.293-1.73l-6.25-9.046a4 4 0 0 1 0-4.557l6.25-8.953a4 4 0 0 1 3.278-1.714h23.773a4 4 0 0 1 4.005 4Z'
            stroke='#0D0D0D'
          />
          <path d='M20.875 17.872 33 29.997m.125-12.125L21 29.997' stroke='#E60000' />
        </g>
        <defs>
          <clipPath id='7dce32a7-0639-42d2-a7fe-38ce7e85d6db__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBackspace
